export {};
//# sourceMappingURL=TypedArrays.types.js.map